module.exports = __webpack_public_path__ + "img/材料力学8_5_1.87dbe375.jpg";